import api from '@/api/client'
import type { AdminUsersResponse } from '../types'

export const adminApi = {
  getUsers: (params?: { search?: string; is_suspended?: boolean; page?: number }): Promise<AdminUsersResponse> =>
    api.get('/admin/users', { params }).then((r) => r.data as AdminUsersResponse),

  suspendUser: (id: string): Promise<void> =>
    api.post(`/admin/users/${id}/suspend`).then((r) => r.data as void),

  reactivateUser: (id: string): Promise<void> =>
    api.post(`/admin/users/${id}/reactivate`).then((r) => r.data as void),

  deleteUser: (id: string): Promise<void> =>
    api.delete(`/admin/users/${id}`).then((r) => r.data as void),

  forcePasswordReset: (id: string): Promise<void> =>
    api.post(`/admin/users/${id}/force-password-reset`).then((r) => r.data as void),

  exportUser: (id: string): Promise<unknown> =>
    api.get(`/admin/users/${id}/export`).then((r) => r.data as unknown),
}
